import { ApolloCache, Reference } from "@apollo/client"
import { CATEGORY_FRAGMENT } from "../fragment/category"

export const updateCacheCategory = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      categories(existing = []) {
        const newCategoryRef = cache.writeFragment({
          data: entryData,
          fragment: CATEGORY_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newCategoryRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newCategoryRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) =>
                el?.__ref !== newCategoryRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newCategoryRef
            }
            return items
        }
      },
      aggregateCategory(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
